document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pf-type="ProductATC"] span').forEach((label) => {
    if (/ORDER FOR ONLY \$\d+(?:\.\d{2})?/i.test(label.textContent)) {
      label.textContent = 'VIEW CURRENT PRICE';
    }
  });

  const stalePolicyClaims = [
    /\$8 Shipping anywhere in the continental United States\.?/i,
    /Standard Shipping\s*3 to 4 business days\s*USPS First Class Shipping\s*2 business days/i
  ];

  document.querySelectorAll('[data-pf-type="Accordion.Content"] span').forEach((content) => {
    if (stalePolicyClaims.some((claim) => claim.test(content.textContent))) {
      content.innerHTML = '<a href="/policies/shipping-policy">View our current shipping policy</a> and <a href="/policies/refund-policy">return and refund policy</a>.';
    }
  });
});
